import React from "react";
import { CardLayout } from "components/cardLayout";
import { companylogo, PaymentCard1, PaymentCard2, PaymentCard3, PaymentCard4 } from "assets/images"
import "./PackingSummaryCard.scss"
import { getEstimatorDetails } from 'core/services/getEstimatorDetailsService'

const _ = require("lodash");
export interface PackingSummaryCardProps {
    isMoveCharge: any

}

export interface PackingSummaryCardState {
    loading: boolean
    data: any,
    title: string,
    subTitle: string,
    footerTiltle: string,
    footerNote: string,
    binding: any
}

class PackingSummaryCard extends React.Component<PackingSummaryCardProps, PackingSummaryCardState> {
    private _isMounted: boolean = false;
    constructor(props: PackingSummaryCardProps) {
        super(props);
        this.state = {
            loading: false,
            title: "Description",
            subTitle: "Quality",
            footerTiltle: "Packaging Materials & Containers",
            footerNote: "",
            binding: "",
            data: [
                {

                    'name': "Dish Pack",
                    'value': '9'
                },
                {

                    'name': '1.2 cartoon',
                    'value': '8'
                },
                {

                    'name': '3.0 cartoon',
                    'value': '4'
                }
            ]
        };
    }

    async fetchData() {
        var CID = localStorage.getItem("CID") || "0";
        let response = await getEstimatorDetails(CID)

    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
        var estDetails = JSON.parse(localStorage.getItem("EstimatorDetails") || "");
        let fees = (parseFloat(estDetails?.loadRate) * parseFloat(estDetails?.loadEstimatedHours) + parseFloat(estDetails?.unloadRate) * parseFloat(estDetails?.unloadEstimatedHours)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        let packing = (parseFloat(estDetails.materialCost) + parseFloat(estDetails.packingCost)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        let binding = parseFloat(estDetails.totalCharges).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        this.setState({ binding: binding })
        //let fuelCharge = parseInt(fuelCharge)
        const transportationValue = ((parseFloat(estDetails?.travelHours) * parseFloat(estDetails?.travelRate)) + parseFloat(estDetails?.additionalCharges)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const additionalCharges = parseFloat(estDetails.otherCharges).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        if (this.props.isMoveCharge) {
            this.setState({
                title: "Services",
                subTitle: "Cost",
                footerTiltle: "Total Binding Cost(Option 1):",
                footerNote: "This estimate(total) is good for 7 days unless signed by all parties.",
                data: [
                    {

                        'name': "Transportation:",
                        'value': "$" + transportationValue,
                        'subTitle': estDetails.fromZip + " to " + estDetails.toZip
                    },
                    {

                        'name': "Origin/Destination Fees:",
                        'value': "$" + fees,
                        'subTitle': 'Labour Total'
                    },
                    {

                        'name': "Fuel Surcharge:",
                        'value': "$" + parseFloat(estDetails.fuelCharge || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'subTitle': 'Round Trip'
                    },
                    {

                        'name': "Packing:",
                        'value': "$" + packing,
                        'subTitle': 'Materials'
                    },
                    {

                        'name': "Advanced Charges:",
                        'value': "$" + additionalCharges,
                        'subTitle': ''
                    },
                    {

                        'name': "Storage (SIT):",
                        'value': "$" + parseFloat(estDetails.storageCharge || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'subTitle': ''
                    },
                    {

                        'name': "Full Value Protection Charge:",
                        'value': "$" + parseFloat(estDetails.protectionCharges || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'subTitle': '$0 Deductible ($' + parseFloat(estDetails.shipmentValue || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ')'
                    },
                    // {

                    //     'name': "Box Removal:",
                    //     'value': "$" + parseFloat(estDetails.junkServiceCharge || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    //     'subTitle': '',
                    //     'willShow': parseFloat(estDetails.junkServiceCharge || 0) == 0 ? false : true
                    // },
                    {

                        'name': "Junk Services:",
                        'value': "$" + parseFloat(estDetails.junkServiceCharge || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'subTitle': '',
                        'willShow': parseFloat(estDetails.junkServiceCharge || 0) == 0 ? false : true
                    },
                    {

                        'name': "Sales Tax:",
                        'value': "$" + parseFloat(estDetails.salesTaxCost || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        'subTitle': '',
                        'willShow': parseFloat(estDetails.salesTaxCost || 0) == 0 ? false : true
                    }
                ]
            })
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        console.log("this.state.data", this.state.data)
        const { title, subTitle, footerTiltle, footerNote } = this.state;
        const total: any = _.sumBy(this.state.data, function (o: any) { return parseFloat(o.value); });
        return (
            <div>
                <CardLayout>
                    <div style={{ display: "flex", width: "100%" }}>
                        <p className="label">{title}</p>
                        <span className="labelSubtitle">{subTitle}</span>
                    </div>
                    <div className="content">
                        {
                            this.state.data.map((ele: any, i: any) => {
                                {
                                    //console.log("ele.willShow:", ele.willShow?.toString(), (ele.willShow == undefined || ele.willShow) && ele.name)
                                    return (ele.willShow == undefined || ele.willShow) &&
                                        (
                                            <div key={i} className={i % 2 === 0 ? "listItem" : "listItemNoBaground"}>
                                                <div>
                                                    <p>{ele.name}</p>
                                                    {ele.subTitle && <span>{ele.subTitle}</span>}
                                                </div>
                                                <h3>{ele.value} {ele.willHide && ele.willHide.toString()}</h3>
                                            </div>
                                        )
                                }
                            })
                        }

                    </div>
                    <div style={{ display: "flex", width: "100%" }}>
                        <p className="footerLabel">{footerTiltle}</p>
                        <span className={this.props.isMoveCharge ? "moveChargeTotal" : "footerLabelSubtitle"}>${this.state.binding}</span>
                    </div>
                    {footerNote && <p className="footerLabel footerNote">{footerNote}</p>}
                </CardLayout>
                {this.props.isMoveCharge &&
                    <CardLayout>
                        <p className="footerLabel">Federal Motor Carrier Safety Association Notice</p>
                        <p className="footerLabel coloredText">WARNING – If a moving company loses or damages your goods, there are 2 different standards for the company’s liability based on the types of rates you pay. BY FEDERAL LAW, THIS FORM MUST CONTAIN A FILLED-IN ESTIMATE OF THE COST OF A MOVE FOR WHICH THE MOVING COMPANY IS LIABLE FOR THE FULL (REPLACEMENT) VALUE OF YOUR GOODS in the event of loss of, or damage to, the goods. This form may also contain an estimate of the cost of a move in which the moving company is liable for FAR LESS that the replacement value of your goods, typically at a lower cost to you. You will select the liability level later, on the bill of lading (contract) for your move. Before selecting a liability level, please read  “Your Rights and Responsibilities When You Move,” provided by the moving company and seek further information at the government website “<a href="www.protectyourmove.gov">www.protectyourmove.gov</a>”.</p>
                        <p className="footerLabel">Accepted Methods of COD Payments</p>
                        <div className="paymentCardDiv">
                            <img className="paymentCardImg" src={PaymentCard1} />
                            <img className="paymentCardImg" src={PaymentCard2} />
                            <img className="paymentCardImg" src={PaymentCard3} />
                            <img className="paymentCardImg" src={PaymentCard4} />
                        </div>
                        <div className="caption">
                            Cash, Credit Card, Debit Card only. No Checks Accepted, Thank you! Payments Required Prior to Unload.
                        </div>
                    </CardLayout>
                }
            </div>
        );
    }
}

export default PackingSummaryCard;